// This lives here because it is on topic and we may want to use is elsewhere someday.
const auxToolTipText =
	'This clone will be created using a ‘hot copy’ method, meaning that all data will be copied from the original VPS to the clone VPS.';

export default auxToolTipText;
